import React from "react";
import ManufacturersSection from "../Home/ManufacturersSection.jsx";

const ManufacturersPage = () => <ManufacturersSection />;

export default ManufacturersPage;
